import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../hooks/use-auth";

const DEFAULT_ERROR = {
  errEmail: "",
  errPassword: "",
  isClicked: false,
  isValid: false,
};

const isEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

const useHandler = () => {
  const { login, isLoading } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  const [data, setData] = useState({
    email: "",
    password: "",
    check: false,
  });
  const [error, setError] = useState(DEFAULT_ERROR);

  const { email, password } = data;
  const { isClicked } = error;

  const onChangeValue = useCallback((e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: name === "email" || name === "password" ? value.trim() : value,
    }));
  }, []);

  const toggleCheck = useCallback(() => {
    setData((prev) => ({ ...prev, check: !prev.check }));
  }, []);

  const onValidate = useCallback(() => {
    let errState = { ...DEFAULT_ERROR, isValid: true, isClicked: true };

    if (!password) {
      errState = {
        ...errState,
        errPassword: "Please Enter Password",
        isValid: false,
      };
    }

    if (!isEmail.test(email)) {
      errState = {
        ...errState,
        errEmail: "Please enter a valid email",
        isValid: false,
      };
    }

    setError(errState);
    return errState;
  }, [email, password]);

  useEffect(() => {
    if (isClicked) onValidate();
  }, [data, isClicked, onValidate]);

  const onSubmit = async () => {
    const { isValid } = onValidate();
    if (!isValid) return;

    try {
      await login(email, password);
    } catch (err) {
      // Error handled by useAuth
    }
  };

  return {
    data,
    showPassword,
    error,
    isLoading,
    onSubmit,
    onChangeValue,
    toggleCheck,
    setShowPassword,
  };
};

export default useHandler;
